<template>
  <v-container>
    <v-row>
      <v-col>
          <h2>TABLAS COMISIONES</h2>
          <CRUDIndex
            :permissionRoot="'Tablas Comisiones'"
            :headers="headers"
            :storeModel="storeModel"
            :itemsPerPage="itemsPerPage"
          />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CRUDIndex from '../globals/CRUDIndex'
export default {
  components: {
    CRUDIndex
  },
  mounted() {
  },
  computed: {
  },
  data () {
    return {
      payload: `?`,
      headers: [
        { text: 'Nombre', value: 'name' },
      ],
      storeModel: 'MultilevelDiscountType',
      storeModelPlural: 'MultilevelDiscountTypes',
      itemsPerPage: 20
    }
  },
}
</script>

<style>

</style>
